import { emulatorScreen, mobileScreen } from "../../../utils/styleUtils";

const styles = (theme) => ({
  questionTitle: {
    color: "#003E4C",
    fontWeight: "600",
    fontSize: 24,
    paddingBottom: 0,
    textAlign: "center",
    // right: 0,
    // position: "absolute",
    fontFamily: "'Oswald',sans-serif",
    // marginLeft: "100px",
    [emulatorScreen(theme)]: {
      padding: "53px 20px 0px 0",
      marginLeft: 12,
      fontSize: "1.3rem",
    },
    [mobileScreen(theme)]: {
      padding: "8px 0 0 43px",
      marginLeft: "-10px",
      fontSize: "1rem",
    },
  },

  questionTitleInternational: {
    color: "#003E4C",
    fontWeight: "600",
    fontSize: 24,
    paddingBottom: 0,
    textAlign: "center",
    // right: 0,
    // position: "absolute",
    fontFamily: "'Oswald',sans-serif",
    // marginLeft: "100px",
    [emulatorScreen(theme)]: {
      padding: "53px 20px 0px 0",
      marginLeft: 35,
      fontSize: "1.3rem",
    },
    [mobileScreen(theme)]: {
      padding: "8px 0 0 43px",
      marginLeft: "-40px",
      fontSize: "1rem",
    },
  },

  graphDiv: {
    display: "flex",
    alignItems: "center",
    marginBottom: "50px",
    // marginTop: 100,
    justifyContent: "space-around",
    [emulatorScreen(theme)]: {
      marginLeft: 10,
      marginBottom: "25px",
    },
    [mobileScreen(theme)]: {
      marginLeft: 10,
      marginBottom: "25px",
    },
  },

  graphDiv2: {
    maxWidth: 565,
    [emulatorScreen(theme)]: {
      maxWidth: 410,
    },
    [mobileScreen(theme)]: {
      maxWidth: 375,
    },
  },

  secondAnswerImage: {
    height: 480,
    [emulatorScreen(theme)]: {
      height: 320,
    },
    [mobileScreen(theme)]: {
      height: 320,
    },
  },

  quizContainer: {
    // marginRight: "100px",
    alignSelf: "flex-start",
    [emulatorScreen(theme)]: {
      marginRight: "0px",
    },
  },

  leftDiv: {
    // marginRight: "100px",
    padding: "60px 0px 0px 0",
    marginLeft: 195,
    [emulatorScreen(theme)]: {
      padding: 0,
      marginLeft: 0,
    },
  },
});
export default styles;
